import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-biometric-modal',
  templateUrl: './biometric-modal.component.html',
  styleUrls: ['./biometric-modal.component.scss'],
  standalone: false
})

export class BiometricModalComponent {

  constructor(
    private modalCtrl: ModalController,
  ) { }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  enableBiometrics() {
    this.modalCtrl.dismiss({ enableBiometric: true });
  }
}
